import { func } from "prop-types";
import { HandleResponse, AuthHeader } from "../_helpers";
import { Url } from "./Url.service";

export const CreditoDirectoServices = {
    calculaCreditoDirecto,
    obtenerPlazos,
    solicitarCreditoDirecto,
    obtenerEstadosSolicitudes,
    obtenerSolicitudesCreditosDirectos,
    SolicitudesCreditoDirectoVendedor,
    SolicitudesCreditoDirectoClientes,
    aprobarCredito,

    //FORMULARIO
    obtenerTiposDocumentos,
    subirDocumentos,
    getCatalogos,
    getInformacionComplementaria,
    GuardarFormularioCredito,
    buscarConyuge,
    guardarConyuge,
    getDocumentosSolicitud,
    enviar_riesgo,
    notificar_finanzas,
    notificar_finanzas_Multiempresas,

    // RESTRICCIONES
    // obtener_restriccion_credito,
    crear_restriccion_credito,
    actualizar_restriccion_credito,
    filtrar_restriccion_credito,
    eliminar_restriccion_credito,

    //COTIZACIONES Y EXTRAS
    cotizarCreditoDirecto,
    listarCotizaciones,
    obtenerCotizacion,
    cotizacion_pdf,
    guardar_formalizar_cotizacion,
    correoAprobacionPrecio,
    correoCotizacionSolicitud,
    solciitudes_credito_directo_multiempresa,

    //VIGENCIAS
    listar_vigencias,
    obtener_vigencia,
    filtrar_vigencia,
    crear_vigencia,
    actualizar_vigencia,
    eliminar_vigencia,

    //PAGOS
    listar_pagos,
    filtrar_pagos,
    listar_solicitudes_pagos,
    registrar_pago_credito,
    aprobarPagoCredito,
    obtener_detalle_pago,
    actualizar_pago_credito,
    upload_comprobante_pago,

    //CONFIGURACIONES DE CREDITO
    crear_configuracion_credito,
    actualizar_configuracion_credito,
    listar_configuracion_credito,
    filtrar_configuracion_credito,
    obtener_configuracion_credito,

    //COBROS
    crear_configuracion_cobro,
    actualizar_configuracion_cobro,
    listar_configuracion_cobro,
    filtrar_configuracion_cobro,
    obtener_configuracion_cobro,
    inactivar_configuracion_cobro,

    //ESTADOS
    crear_estados,
    actualizar_estados,
    listar_estados,
    filtrar_estados,
    inactivar_estados,
    obtener_estado,
    obtenerPlazosCliente,
    obtenerTodosLosPlazos,
};

function calculaCreditoDirecto(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/tabla_amortizacion`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function cotizarCreditoDirecto(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/cotizaciones/simular`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listarCotizaciones() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/cotizaciones`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtenerCotizacion(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };
    return fetch(`${Url}credito_directo/cotizaciones/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function guardar_formalizar_cotizacion({ id_cotizacion, ...data }) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/cotizaciones/actualizar/${id_cotizacion}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function cotizacion_pdf(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
            Accept: "application/pdf,application/json;q=0.9,*/*;q=0.8",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/cotizaciones/generar_pdf`, requestOptions).then(async (response) => {
        if (!response.ok) {
            const text = await response.text();
            let error = response.statusText;

            try {
                const json = text ? JSON.parse(text) : null;
                error = json?.text?.message || json?.message || error;
            } catch (parseError) {
                // Ignorar si no es JSON.
            }

            throw new Error(error);
        }

        const contentType = response.headers.get("content-type") || "";

        if (contentType.includes("application/json")) {
            const text = await response.text();
            return text ? JSON.parse(text) : {};
        }

        return response.blob();
    });
}

function obtenerPlazos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/plazos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function solicitarCreditoDirecto(data) {
    const payload = (typeof data === 'number' || typeof data === 'string')
        ? { id_solicitud_multiempresa: Number(data) }
        : data;

    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    };

    return fetch(`${Url}credito_directo`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtenerEstadosSolicitudes() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/estados`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtenerSolicitudesCreditosDirectos(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    const query = new URLSearchParams(params).toString();

    return fetch(`${Url}credito_directo?${query}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}


function SolicitudesCreditoDirectoVendedor(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    const query = new URLSearchParams(params).toString();

    return fetch(`${Url}credito_directo/creditoVendedor?${query}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function SolicitudesCreditoDirectoClientes(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    const query = new URLSearchParams(params).toString();

    return fetch(`${Url}credito_directo/creditosClientes?${query}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function aprobarCredito(formData) {
    // 1. Obtenemos los headers de autenticación
    const headers = { ...AuthHeader() };

    // 2. ELIMINAMOS EL CONTENT-TYPE MANUALMENTE (La magia ocurre aquí)
    delete headers['Content-Type'];

    const requestOptions = {
        method: "POST",
        headers: headers, // Usamos los headers ya limpios
        body: formData,
    };

    return fetch(`${Url}credito_directo/aprobar`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtenerTiposDocumentos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/tipos_documentos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function subirDocumentos() {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/subir_documentos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function getInformacionComplementaria(idSolicitud) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    const qs = idSolicitud ? `?solicitud=${idSolicitud}` : '';
    return fetch(`${Url}credito_directo/data_formulario${qs}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function getCatalogos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/catalogos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function GuardarFormularioCredito(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/guardar_configuracion`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function buscarConyuge(cedula) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };
    const qs = cedula ? `?cedula=${encodeURIComponent(cedula)}` : '';
    return fetch(`${Url}credito_directo/buscar_conyuge${qs}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function guardarConyuge(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_conyuge`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function enviar_riesgo(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/enviar_riesgo`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function notificar_finanzas(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/notificar_finanzas`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function notificar_finanzas_Multiempresas(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/notificar_finanzas_multiempresas`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function getDocumentosSolicitud(idSolicitud) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/documentos/${idSolicitud}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

// function obtener_restriccion_credito(idSolicitud)
// {
//     const requestOptions = {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//         },
//     };

//     return fetch(`${Url}credito_directo/obtener_restriccion_credito/${idSolicitud}`, requestOptions)
//         .then(HandleResponse)
//         .then(response => response);
// }

function crear_restriccion_credito(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_restriccion_credito`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_restriccion_credito(idRestriccion, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_restriccion_credito/${idRestriccion}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function eliminar_restriccion_credito(idRestriccion) {
    const requestOptions = {
        method: "DELETE",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/eliminar_restriccion_credito/${idRestriccion}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_restriccion_credito(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/filtrar_restriccion_credito?${params}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function correoAprobacionPrecio(data) {
    const payload = (typeof data === 'number' || typeof data === 'string')
        ? { id_solicitud_multiempresa: Number(data) }
        : data;

    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    };

    return fetch(`${Url}credito_directo/cotizaciones/correo_aprobacion_precio`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function correoCotizacionSolicitud(data) {
    const payload = (typeof data === 'number' || typeof data === 'string')
        ? { id_cotizacion: Number(data) }
        : data;

    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    };

    return fetch(`${Url}credito_directo/cotizaciones/enviar`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function solciitudes_credito_directo_multiempresa(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/solicitudes_credito_empresa/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_vigencias() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/listar_vigencias`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtener_vigencia(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtener_vigencia/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_vigencia(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    const qs = params ? `?${params}` : "";

    return fetch(`${Url}credito_directo/filtrar_vigencia${qs}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function crear_vigencia(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_vigencia`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_vigencia(id, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_vigencia/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function eliminar_vigencia(id) {
    const requestOptions = {
        method: "DELETE",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/eliminar_vigencia/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_pagos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/listar_pagos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_solicitudes_pagos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/solicitudes_pagos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_pagos(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/filtrar_pagos?${params}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function registrar_pago_credito(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/registrar_pago_credito`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function aprobarPagoCredito(idPago) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/aprobar_pago_credito/${idPago}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}
function rechazar_pago_credito(idCabecera, data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/rechazar_pago_credito/${idCabecera}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function rechazar_detalle_pago(idDetalle, data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/rechazar_detalle_pago/${idDetalle}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtener_detalle_pago(idPago) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtener_detalle_pago/${idPago}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_pago_credito(idPago, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_pago_credito/${idPago}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function upload_comprobante_pago(file) {
    const formData = new FormData();
    formData.append('file', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            ...AuthHeader(),
        },
        body: formData,
    };

    return fetch(`${Url}credito_directo/upload_comprobante_pago`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

//CONFIGURACION CREDITO
function crear_configuracion_credito(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_configuracion_credito`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_configuracion_credito(id, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_configuracion_credito/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_configuracion_credito() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/listar_configuracion_credito`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtener_configuracion_credito(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtener_configuracion_credito/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_configuracion_credito(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/filtrar_configuracion_credito?${params}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function inactivar_configuracion_credito(id) {
    const requestOptions = {
        method: "DELETE",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/inactivar_configuracion_credito/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}


// COBROS
function crear_configuracion_cobro(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_configuracion_cobro`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_configuracion_cobro(id, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_configuracion_cobro/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_configuracion_cobro() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/listar_configuracion_cobro`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtener_configuracion_cobro(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtener_configuracion_cobro/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_configuracion_cobro(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/filtrar_configuracion_cobro?${params}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function inactivar_configuracion_cobro(id) {
    const requestOptions = {
        method: "DELETE",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/inactivar_configuracion_cobro/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

// ESTADOS
function crear_estados(data) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/crear_estados`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function listar_estados(tipo) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };
    return fetch(`${Url}credito_directo/listar_estados?tipo=${tipo}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function actualizar_estados(id, data) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    return fetch(`${Url}credito_directo/actualizar_estados/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtener_estado(id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtener_estado/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function inactivar_estados(id) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/inactivar_estados/${id}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function filtrar_estados(params) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/filtrar_estados?${params}`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}


function obtenerPlazosCliente() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/plazos_cliente`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}

function obtenerTodosLosPlazos() {
    const requestOptions = {
        method: "GET",
        headers: {
            ...AuthHeader(),
            "Content-Type": "application/json",
        },
    };

    return fetch(`${Url}credito_directo/obtenerTodosLosPlazos`, requestOptions)
        .then(HandleResponse)
        .then(response => response);
}